import React, { VFC } from 'react';
import styled from 'styled-components';

import NotLoggedInContent from './NotLoggedInContent';
import SearchIconLink from '../molecules/SearchIconLink';
import NotificationIconLink from '../molecules/NotificationIconLink';
import ChatIconLink from '../molecules/ChatIconLink';
import UserHistoryIconLink from '../molecules/UserHistoryIconLink';
import PCLogo from '../atoms/PCLogo';
import HomeLink from '../atoms/HomeLink';

// js codes
import AccountMenu from './AccountMenu';
import FavoritePlansIconLink from '../molecules/FavoritePlansIconLink';

const RightWrapper = styled.div`
  display: flex;
  margin-left: auto;
  align-items: center;
`;

interface Props {
  authenticated: boolean;
  imageUrl?: string | null;
  profileMenuEl: Element | null;
  handleOpenSearchDrawer: () => void;
  handleOpenProfileMenu: (anchorEl: Element | null) => void;
}
const PCHeaderContent: VFC<Props> = ({
  authenticated,
  imageUrl,
  profileMenuEl,
  handleOpenSearchDrawer,
  handleOpenProfileMenu,
}: Props) => {
  return (
    <>
      <HomeLink>
        <PCLogo />
      </HomeLink>
      <RightWrapper>
        {authenticated ? (
          <>
            <SearchIconLink onClick={handleOpenSearchDrawer} />
            <NotificationIconLink />
            <ChatIconLink />
            <FavoritePlansIconLink />
            <UserHistoryIconLink />
            <AccountMenu
              loaded={true}
              imageUrl={imageUrl}
              profileMenuEl={profileMenuEl}
              handleOpenProfileMenu={handleOpenProfileMenu}
            />
          </>
        ) : (
          <NotLoggedInContent handleOpenSearchDrawer={handleOpenSearchDrawer} />
        )}
      </RightWrapper>
    </>
  );
};

export default PCHeaderContent;
